export default __webpack_public_path__ + "static/media/lockOpen.db0aeb9c.svg";